import {sendRequest, urls} from '../../apiRequestService';
import {IActionData} from '../../apiRequestService/types';
import {requestMethod, responseType} from '../../globalConstants';

export const getProfileInfo = (data: IActionData) => {
    return sendRequest(urls.PROFILE_INFO, requestMethod.GET, responseType.JSON, data);
};
